export default __webpack_public_path__ + "static/5-045dbf6472487d9928f46a7734b52194.png";